
import { computed, defineComponent } from 'vue'
import { useGlobalConfig } from '@/components/utils/util'
import { isValidComponentSize } from '@/components/utils/validators'

import type { PropType } from 'vue'

export default defineComponent({
  name: 'MsTag',

  inject: ['closeIconCustom'],

  props: {
    closable: Boolean,
    type: {
      type: String,
      default: ''
    },
    customTag: Boolean,
    hit: Boolean,
    disableTransitions: Boolean,
    color: {
      type: String,
      default: ''
    },
    size: {
      // eslint-disable-next-line no-undef
      type: String as PropType<ComponentSize>,
      default: '',
      validator: isValidComponentSize
    },
    effect: {
      type: String,
      default: 'light',
      validator: (val: string): boolean => {
        return ['dark', 'light', 'plain'].indexOf(val) !== -1
      }
    }
  },

  emits: ['close', 'click'],

  setup (props, ctx) {
    const ELEMENT = useGlobalConfig()

    const tagSize = computed(() => {
      return props.size || ELEMENT.size
    })
    const classes = computed(() => {
      const { type, hit, effect } = props
      return [
        'el-tag',
        'ms-tag',
        props.customTag ? 'custom-tag' : '',
        type ? `el-tag--${type}` : '',
        tagSize.value ? `el-tag--${tagSize.value}` : '',
        effect ? `el-tag--${effect}` : '',
        hit && 'is-hit'
      ]
    })

    // methods
    const handleClose = (event: Event) => {
      event.stopPropagation()
      ctx.emit('close', event)
    }

    const handleClick = (event: Event) => {
      ctx.emit('click', event)
    }

    return {
      tagSize,
      classes,
      handleClose,
      handleClick
    }
  }
})
